(() => {
  const SELECTORS = {
    headerMenus: '.section-header .clovant-header__shop-menu, .section-header details.menu-drawer-container',
    hero: '[data-ah-hero]',
    quickOrder: '[data-ah-quick-order]'
  };

  function initHeaderDismissal() {
    if (document.documentElement.dataset.ahHeaderDismissal === 'ready') return;
    document.documentElement.dataset.ahHeaderDismissal = 'ready';

    const openMenus = () => Array.from(document.querySelectorAll(`${SELECTORS.headerMenus}[open]`));

    document.addEventListener('pointerdown', (event) => {
      openMenus().forEach((menu) => {
        if (!menu.contains(event.target)) menu.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const menu = openMenus().at(-1);
      if (!menu) return;
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  }

  function initHero(root) {
    if (root.dataset.ahReady === 'true') return;
    root.dataset.ahReady = 'true';

    const slides = Array.from(root.querySelectorAll('[data-ah-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-ah-dot]'));
    const previous = root.querySelector('[data-ah-previous]');
    const next = root.querySelector('[data-ah-next]');
    const pause = root.querySelector('[data-ah-pause]');
    const status = root.querySelector('[data-ah-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval = Number(root.dataset.interval || 6500);
    let active = 0;
    let paused = reducedMotion.matches;
    let timer;

    if (slides.length < 2) {
      root.querySelector('[data-ah-controls]')?.setAttribute('hidden', '');
      return;
    }

    function render(announce = false) {
      slides.forEach((slide, index) => {
        slide.hidden = index !== active;
        slide.setAttribute('aria-hidden', index === active ? 'false' : 'true');
      });
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === active);
        dot.setAttribute('aria-selected', index === active ? 'true' : 'false');
        dot.tabIndex = index === active ? 0 : -1;
      });
      if (announce && status) status.textContent = `Promotion ${active + 1} of ${slides.length}`;
    }

    function stopTimer() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function startTimer() {
      stopTimer();
      if (paused || reducedMotion.matches || document.hidden) return;
      timer = window.setInterval(() => {
        active = (active + 1) % slides.length;
        render(false);
      }, interval);
    }

    function choose(index, announce = true) {
      active = (index + slides.length) % slides.length;
      render(announce);
      startTimer();
    }

    previous?.addEventListener('click', () => {
      paused = true;
      updatePause();
      choose(active - 1);
    });

    next?.addEventListener('click', () => {
      paused = true;
      updatePause();
      choose(active + 1);
    });

    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      paused = true;
      updatePause();
      choose(index);
    }));

    function updatePause() {
      if (!pause) return;
      pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pause.setAttribute('aria-label', paused ? 'Play rotating promotions' : 'Pause rotating promotions');
      const symbol = pause.querySelector('[data-ah-pause-symbol]');
      if (symbol) symbol.textContent = paused ? '▶' : 'Ⅱ';
    }

    pause?.addEventListener('click', () => {
      paused = !paused;
      updatePause();
      startTimer();
    });

    reducedMotion.addEventListener?.('change', () => {
      if (reducedMotion.matches) paused = true;
      updatePause();
      startTimer();
    });
    document.addEventListener('visibilitychange', startTimer);

    render(false);
    updatePause();
    startTimer();
  }

  function initQuickOrder(root) {
    if (root.dataset.ahReady === 'true') return;
    root.dataset.ahReady = 'true';
    const form = root.querySelector('form');
    const input = root.querySelector('input[name="q"]');
    const message = root.querySelector('[data-ah-quick-message]');
    if (!form || !input || !message) return;

    form.addEventListener('submit', (event) => {
      if (input.value.trim()) return;
      event.preventDefault();
      message.textContent = 'Enter a product, brand or SKU first.';
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    });

    input.addEventListener('input', () => {
      if (!message.textContent) return;
      message.textContent = '';
      input.removeAttribute('aria-invalid');
    });
  }

  function init(root = document) {
    initHeaderDismissal();
    root.querySelectorAll(SELECTORS.hero).forEach(initHero);
    root.querySelectorAll(SELECTORS.quickOrder).forEach(initQuickOrder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-ah-slide]');
    const hero = slide?.closest('[data-ah-hero]');
    if (!slide || !hero) return;
    const slides = Array.from(hero.querySelectorAll('[data-ah-slide]'));
    const dot = hero.querySelectorAll('[data-ah-dot]')[slides.indexOf(slide)];
    dot?.click();
  });
})();
